import React, { useState } from 'react';
import { Layout, Menu, Button, Drawer, Grid } from 'antd';
import { Link, useLocation } from 'react-router';
import { MenuOutlined } from '@ant-design/icons';
import { IMenuItem } from '../types/menu';
const { Header, Content, Footer } = Layout;
const { useBreakpoint } = Grid;

interface GuestLayoutProps {
  children: React.ReactNode;
}

const headerStyle: React.CSSProperties = {
  height: 65,
  padding: '0 24px',
  lineHeight: '64px',
  borderBottom: '1px solid #e0e0e0',
};

const contentStyle: React.CSSProperties = {
  textAlign: 'center',
  minHeight: 120,
  // lineHeight: '120px',
  backgroundColor: '#ffffff',
};

const footerStyle: React.CSSProperties = {
  textAlign: 'center',
  backgroundColor: '#f0f2f6',
};

const layoutStyle = {
  overflow: 'hidden',
  minHeight: '100dvh',
};

const logoStyle: React.CSSProperties = {
  height: '40px',
  marginTop: '-5px',
};

export const GuestLayout: React.FC<GuestLayoutProps> = ({ children }) => {
  const location = useLocation();
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
  const screens = useBreakpoint();

  const menuItems: IMenuItem[] = [
    {
      key: '/plans',
      style: { fontWeight: '500' },
      label: <Link to="/plans">Plans</Link>,
    },
    {
      key: '/login',
      style: { marginLeft: 'auto' },
      label: <Link to="/login">Log in</Link>,
    },
  ];

  const selected = location.pathname ? '/' + location.pathname.split('/')[1] : '/';

  if (screens.md) {
    menuItems.unshift({
      key: 'logo',
      disabled: true,
      style: { pointerEvents: 'none' },
      label: <img src="/public/images/logo.png" alt="menu" style={logoStyle} />,
    });
  }

  return (
    <Layout style={layoutStyle}>
      <Header style={headerStyle}>
        {screens.md ? (
          <Menu
            theme="light"
            mode="horizontal"
            defaultSelectedKeys={['/']}
            selectedKeys={[selected]}
            items={menuItems}
          />
        ) : (
          <>
            <Link to="/dashboard">
              <img src="/public/images/logo.png" alt="menu" style={logoStyle} />
            </Link>
            <Button
              type="text"
              size="large"
              icon={<MenuOutlined style={{ fontSize: '20px' }} />}
              onClick={() => setMobileMenuVisible(true)}
              style={{ color: '#000', float: 'right', top: '25%' }}
            />
          </>
        )}
      </Header>

      {/* Mobile Menu Drawer */}
      <Drawer
        title="Menu"
        placement="right"
        onClose={() => setMobileMenuVisible(false)}
        open={mobileMenuVisible}>
        <Menu mode="inline" items={menuItems} onClick={() => setMobileMenuVisible(false)} />
      </Drawer>

      <Content style={contentStyle}>{children}</Content>
      <Footer style={footerStyle}>© 2025 HomeWiP Inc.</Footer>
    </Layout>
  );
};
